<template>
    <div id="common--collect" :class="{ active: active }" @click="toggleStatus" v-if="!isFixed">
        <i class="common--collect--icon"></i>
        <span class="common--collect--text">{{ active ? '已收藏' : '收藏' }}</span>
    </div>
    <div id="common--collect__fixed" :class="{ active: active }" @click="toggleStatus" v-else>
        <div class="collect">
            <i class="collect--icon"></i>
            <span class="collect--text">{{ active ? '已收藏' : '收藏' }}</span>
        </div>
    </div>
</template>

<script>
const ZZCFL = window.ZZCFL;
import {
    privilegeCollect,
    privilegeCancelCollect,
    privilegeCollectStatus,
} from 'root/common/components/modules/collect.js';

export default {
    props: {
        width: {
            type: String,
            default: '1rem',
        },
        isFixed: {
            type: Boolean,
            default: false,
        },
        tracking: {
            type: Object,
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    data() {
        return {
            active: false,
            couponId: ZZCFL.Utils.getUrlQuery('collectBusinessId'),
        };
    },
    created() {
        if (this.$route && this.$route.query && this.$route.query.collectBusinessId) {
            this.couponId = this.$route.query.collectBusinessId;
        }
        if (this.couponId) {
            this.$emit('change', true);
            this.privilegeCollectStatus();
        } else {
            this.value = false;
            this.$emit('change', false);
        }
    },
    methods: {
        // 收藏切换
        async toggleStatus() {
            this.$emit('toggleCollect', !this.active);
            // Pv统计
            this.tracking &&
                window.bigTj.track('click', {
                    obj_id: 'collect_button',
                    obj_type: this.tracking.obj_type,
                    ...this.tracking.option,
                    item_type: !this.active ? 1 : 0,
                });
            if (!this.active) {
                await this.privilegeCollect();
            } else {
                await this.privilegeCancelCollect();
            }
        },

        // 特权收藏
        async privilegeCollect() {
            let result = await privilegeCollect({
                coupon_id: this.couponId,
            });

            if (result) {
                this.active = true;
                ZZCFL.Toast(result.msg);
            }
        },

        // 取消收藏
        async privilegeCancelCollect() {
            let result = await privilegeCancelCollect({
                coupon_id: this.couponId,
            });

            if (result) {
                if (result.code == 0) {
                    this.active = false;
                }
                ZZCFL.Toast(result.msg);
            }
        },

        async privilegeCollectStatus() {
            let result = await privilegeCollectStatus({
                coupon_id: this.couponId,
            });

            if (result) {
                if (result.code == 0) {
                    if (result.data.collected) {
                        this.active = true;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#common--collect {
    display: flex;
    padding: 0.12rem 0;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    background: #fff;
    box-sizing: border-box;

    &.active {
        .common--collect--icon {
            background: url('../../../../common/components/images/collect-icon_active.png') no-repeat center/100%;
        }
    }

    .common--collect--icon {
        display: inline-block;
        width: 0.46rem;
        height: 0.39rem;
        background: url('../../../../common/components/images/collect-icon.png') no-repeat center/100%;
    }

    .common--collect--text {
        line-height: 0.2rem;
        font-size: 0.2rem;
        color: #333;
    }
}

#common--collect__fixed {
    position: fixed;
    width: 1.32rem;
    height: 1rem;
    right: 0;
    top: 1.33rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 1rem 0 0 1rem;
    z-index: 20;

    &.active {
        .collect .collect--icon {
            background: url('../../../../common/components/images/collect-icon_active.png') no-repeat center/100%;
        }
    }

    .collect {
        position: absolute;
        top: 50%;
        left: 56%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        transform: translate(-50%, -50%);

        .collect--icon {
            display: inline-block;
            margin-bottom: 0.06rem;
            width: 0.46rem;
            height: 0.39rem;
            background: url('../../../../common/components/images/collect-icon_fixed.png') no-repeat center/100%;
        }

        .collect--text {
            color: #fff;
            white-space: nowrap;
        }
    }
}
</style>
